var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backdrop",class:{ active: _vm.Store.state.productRegisterModal.open },on:{"click":function($event){return _vm.Store.closeProductRegisterModal()}}})}
var staticRenderFns = []

export { render, staticRenderFns }